/**
 * @created on 2017/10/24
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 课程板块
const lessonIndex = resolve =>
  require(['../../../views/lesson/lessonIndex'], resolve)
const lessonMyProfit = resolve =>
  require(['../../../views/lesson/lessonMyProfit'], resolve)
const lessonOrderList = resolve =>
  require(['../../../views/lesson/lessonOrder'], resolve)
const lessonMessageList = resolve =>
  require(['../../../views/lesson/lessonMessage'], resolve)
const lessonNewIndex = resolve =>
  require(['../../../views/lesson/components/lessonNewIndex'], resolve)
const lessonCenter = resolve =>
  require(['../../../views/lesson/components/lessonCenter'], resolve)
const lessonClassify = resolve =>
  require(['../../../views/lesson/lessonClassify'], resolve)
const lessonSchool = resolve =>
  require(['../../../views/lesson/components/lessonSchool'], resolve)
const lessonSearch = resolve =>
  require(['../../../views/lesson/lessonSearch'], resolve)
const lessonMyPresent = resolve =>
  require(['../../../views/lesson/lessonMyPresent'], resolve)
const lessonPresentPage = resolve =>
  require(['../../../views/lesson/lessonPresentPage'], resolve)
const lessonGetPresent = resolve =>
  require(['../../../views/lesson/lessonGetPresent'], resolve)
const lessonStartGroup = resolve =>
  require(['../../../views/lesson/group/lessonStartGroup'], resolve)
const lessonGroupDetail = resolve =>
  require(['../../../views/lesson/group/lessonGroupDetail'], resolve)
const lessonMyGroup = resolve =>
  require(['../../../views/lesson/group/lessonMyGroup'], resolve)
const lessonParticipantsEdit = resolve =>
  require(['../../../views/lesson/lessonParticipantsEdit'], resolve)
const completeAnAddress = resolve =>
  require(['../../../views/lesson/completeAnAddress'], resolve)
const lessonFindMyLessonGuide = resolve =>
  require(['../../../views/lesson/lessonFindMyLessonGuide'], resolve) // 找回课程引导

export default [
  {
    path: '/',
    redirect: '/lesson-index',
    component: lessonIndex,
    children: [
      {
        path: '/lesson-index',
        component: lessonNewIndex,
        name: 'lessonSchool',
        meta: {
          title: '壹心理学院'
        }
      },
      {
        path: '/lesson-index/center',
        component: lessonCenter,
        name: 'lessonCenter',
        meta: {
          title: '课程中心'
        }
      }
    ]
  },
  {
    path: '/teacher',
    component: lessonSchool,
    name: 'lessonSchool',
    meta: {
      title: '咨询师课程'
    }
  },
  {
    path: '/lesson-my-profit',
    component: lessonMyProfit,
    meta: {
      title: '我的收益'
    }
  },
  {
    path: '/lesson-order-list',
    component: lessonOrderList,
    name: 'lesson-order-list',
    meta: {
      title: '我的课程'
    }
  },
  {
    path: '/lesson-message-list',
    component: lessonMessageList,
    name: 'lesson-message-list',
    meta: {
      title: '我的消息'
    }
  },
  {
    path: '/lesson-classify',
    component: lessonClassify,
    name: 'lesson-classify',
    meta: {
      title: '课程分类'
    }
  },
  {
    path: '/lesson-search',
    component: lessonSearch,
    name: 'lesson-search',
    meta: {
      title: '壹心理学院'
    }
  },
  {
    path: '/lesson-my-present',
    component: lessonMyPresent,
    name: 'lesson-my-present',
    meta: {
      title: '我的赠送'
    }
  },
  {
    path: '/lesson-get-present/:id',
    component: lessonGetPresent,
    name: 'lesson-get-present',
    meta: {
      title: '领取礼物'
    }
  },
  {
    path: '/lesson-present-page/:id',
    component: lessonPresentPage,
    name: 'lesson-present-page',
    meta: {
      title: '赠送好友'
    }
  },
  {
    path: '/lesson-start-group/:id',
    component: lessonStartGroup,
    name: 'lesson-start-group',
    meta: {
      title: '我要开团'
    }
  },
  {
    path: '/lesson-group-detail/:id',
    component: lessonGroupDetail,
    name: 'lesson-group-detail',
    meta: {
      title: '拼团详情'
    }
  },
  {
    path: '/lesson-my-group',
    component: lessonMyGroup,
    name: 'lesson-my-group',
    meta: {
      title: '我的拼团'
    }
  },
  {
    path: '/lesson-participants-edit/:id',
    component: lessonParticipantsEdit,
    name: 'lesson-participants-edit',
    meta: {
      title: '第三届中国心理学创新峰会参会人员信息填写'
    }
  },
  {
    path: '/complete-an-address/:lessonId',
    component: completeAnAddress,
    name: 'complete-an-address',
    meta: {
      title: '填写收货地址'
    }
  },
  {
    path: '/lesson_find_my_lesson',
    component: lessonFindMyLessonGuide,
    name: 'lesson-participants-edit',
    meta: {
      title: '找回我的课程'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/page/lesson/index.js